export const WEBHOOK_EVENT_TYPES = {
  PARTNER_DEAL_OPENED: 'partner_deal_opened',
  PARTNER_DEAL_CLOSED_WON: 'partner_deal_closed_won',
  NET_NEW_ACCOUNTS: 'partner_greenfield_deal_closed_won',
  OWN_DEAL_OPENED: 'own_deal_opened',
  OWN_DEAL_CLOSED_WON: 'own_deal_closed_won',
} as const;
